module.exports = __webpack_public_path__ + "img/logo.06325ab6.png";